var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthyLifestyleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2547_781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2285 18.5564C19.2787 18.0559 19.6215 16.5841 18.9973 15.2766C18.372 13.9647 17.013 13.3043 15.9628 13.8048C14.9126 14.3052 14.5698 15.777 15.1951 17.089C15.8204 18.3987 17.1794 19.059 18.2285 18.5564Z",
    fill: "url(#paint0_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3766 10.7275C22.3863 17.0473 17.8887 21.7847 17.8887 21.7847C17.8887 21.7847 14.1808 15.5109 7.94531 13.6175C20.0745 22.4866 13.1711 33.5438 13.1711 33.5438H16.682C16.682 33.5438 24.8437 19.4598 21.3766 10.7275Z",
    fill: "url(#paint1_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5307 11.4493C14.4628 11.3485 14.3938 11.2412 14.3249 11.1229C14.004 10.5688 13.8572 10.0541 13.8572 10.0541C13.8572 10.0541 14.2274 10.4418 14.5482 10.9926C14.6151 11.1098 14.6731 11.2248 14.7268 11.3343C14.7771 11.0704 14.8363 10.5283 14.58 10.0815C14.2263 9.46936 13.4115 9.27881 13.4115 9.27881C13.4115 9.27881 13.1684 10.0804 13.5221 10.6937C13.7784 11.1405 14.2778 11.3606 14.5307 11.4493Z",
    fill: "url(#paint2_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.583 16.0979C22.7867 16.2731 23.2269 16.595 23.7405 16.595C24.448 16.595 25.0196 15.9829 25.0196 15.9829C25.0196 15.9829 24.449 15.3718 23.7405 15.3718C23.2269 15.3718 22.7867 15.6938 22.583 15.869C22.7046 15.8602 22.8316 15.8537 22.9685 15.8537C23.608 15.8537 24.1304 15.9807 24.1304 15.9807C24.1304 15.9807 23.608 16.1099 22.9685 16.1088C22.8305 16.1143 22.7046 16.1066 22.583 16.0979Z",
    fill: "url(#paint3_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0137 10.9948C20.3323 10.4407 20.7047 10.0541 20.7047 10.0541C20.7047 10.0541 20.5568 10.571 20.236 11.1251C20.1681 11.2412 20.0991 11.3507 20.029 11.4515C20.2852 11.3628 20.7835 11.1416 21.0387 10.6981C21.3935 10.0837 21.1526 9.28101 21.1526 9.28101C21.1526 9.28101 20.3356 9.47484 19.983 10.0848C19.7267 10.5294 19.7837 11.0704 19.8352 11.3376C19.8855 11.227 19.9447 11.112 20.0137 10.9948Z",
    fill: "url(#paint4_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9949 7.65906C16.9949 6.23435 17.2808 5.08122 17.2808 5.08122C17.2808 5.08122 17.5677 6.23654 17.5677 7.65906C17.5677 7.96021 17.5534 8.24494 17.5315 8.51433C17.9236 8.06206 18.6387 7.08195 18.6387 5.93867C18.6387 4.36612 17.2808 3.09253 17.2808 3.09253C17.2808 3.09253 15.9229 4.36612 15.9229 5.93867C15.9229 7.08195 16.6379 8.06096 17.0289 8.51433C17.0092 8.24494 16.9949 7.96131 16.9949 7.65906Z",
    fill: "url(#paint5_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90305 12.138C8.8941 12.7097 10.0987 12.5793 10.6868 12.4666C10.4437 12.3527 10.1885 12.2191 9.92897 12.0701C8.69589 11.3594 7.83953 10.5348 7.83953 10.5348C7.83953 10.5348 8.98171 10.8633 10.2148 11.5751C10.4754 11.7263 10.7152 11.8796 10.9386 12.034C10.7437 11.4667 10.2542 10.3585 9.26205 9.78686C7.90195 8.99949 6.11914 9.53828 6.11914 9.53828C6.11914 9.53828 6.54185 11.3528 7.90305 12.138Z",
    fill: "url(#paint6_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6564 19.8288C25.6665 19.2583 24.4619 19.3864 23.8738 19.4992C24.118 19.6142 24.3721 19.7478 24.6327 19.8967C25.8647 20.6085 26.7222 21.432 26.7222 21.432C26.7222 21.432 25.58 21.1046 24.3458 20.3928C24.0852 20.2406 23.8454 20.0873 23.623 19.9328C23.818 20.5001 24.3075 21.6072 25.2974 22.1789C26.6575 22.9663 28.4415 22.4275 28.4415 22.4275C28.4415 22.4275 28.0166 20.614 26.6564 19.8288Z",
    fill: "url(#paint7_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9368 19.936C10.7134 20.0882 10.4747 20.2416 10.214 20.3938C8.98097 21.1034 7.8377 21.4352 7.8377 21.4352C7.8377 21.4352 8.69406 20.6095 9.92713 19.8977C10.1889 19.7455 10.4429 19.6174 10.686 19.5002C10.0991 19.3863 8.89227 19.256 7.90231 19.8298C6.54111 20.615 6.11621 22.4285 6.11621 22.4285C6.11621 22.4285 7.89902 22.9672 9.26022 22.1821C10.2524 21.6082 10.7419 20.5011 10.9368 19.936Z",
    fill: "url(#paint8_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.624 12.0296C23.8463 11.8774 24.0862 11.7241 24.349 11.573C25.581 10.8612 26.7231 10.5326 26.7231 10.5326C26.7231 10.5326 25.8679 11.3572 24.6337 12.068C24.3731 12.2191 24.1179 12.3505 23.877 12.4644C24.4629 12.5783 25.6697 12.7097 26.6574 12.1359C28.0197 11.3496 28.4435 9.5361 28.4435 9.5361C28.4435 9.5361 26.6618 8.99841 25.3017 9.78469C24.3085 10.3563 23.8179 11.4646 23.624 12.0296Z",
    fill: "url(#paint9_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9817 7.48008C11.778 7.18112 11.571 6.85917 11.3684 6.50874C10.4135 4.85734 9.9722 3.32421 9.9722 3.32421C9.9722 3.32421 11.0782 4.47187 12.0321 6.12765C12.2347 6.47589 12.4088 6.81646 12.5643 7.14389C12.7176 6.35652 12.8917 4.74126 12.1252 3.41401C11.0717 1.58849 8.64057 1.01904 8.64057 1.01904C8.64057 1.01904 7.9189 3.40853 8.97238 5.23296C9.73895 6.5613 11.2261 7.21726 11.9817 7.48008Z",
    fill: "url(#paint10_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5807 24.4873C22.7844 24.7863 22.9935 25.1071 23.195 25.4565C24.1511 27.1144 24.5913 28.6432 24.5913 28.6432C24.5913 28.6432 23.4852 27.4944 22.5292 25.8408C22.3277 25.4904 22.1525 25.1498 21.997 24.8246C21.847 25.612 21.6718 27.2239 22.4372 28.5523C23.4918 30.3767 25.9218 30.9483 25.9218 30.9483C25.9218 30.9483 26.6468 28.5567 25.5922 26.7322C24.8234 25.405 23.3374 24.749 22.5807 24.4873Z",
    fill: "url(#paint11_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11937 16.3683C4.21063 16.3683 2.66326 15.9829 2.66326 15.9829C2.66326 15.9829 4.21063 15.5974 6.11937 15.5974C6.52456 15.5974 6.90674 15.6193 7.26703 15.6456C6.66144 15.1199 5.34952 14.1606 3.8142 14.1606C1.70834 14.1617 0 15.9829 0 15.9829C0 15.9829 1.70944 17.8051 3.8142 17.804C5.34843 17.804 6.66035 16.8458 7.26593 16.3213C6.90565 16.3486 6.52237 16.3683 6.11937 16.3683Z",
    fill: "url(#paint12_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7467 14.165C29.2135 14.165 27.9016 15.12 27.2949 15.6478C27.6563 15.6204 28.0396 15.5996 28.4415 15.6007C30.3513 15.6007 31.8976 15.9851 31.8976 15.9851C31.8976 15.9851 30.3513 16.3706 28.4437 16.3706C28.0396 16.3706 27.6563 16.3497 27.2949 16.3235C27.9005 16.848 29.2135 17.8062 30.7467 17.8062C32.8536 17.8062 34.5598 15.9873 34.5598 15.9873C34.5598 15.9873 32.8514 14.1629 30.7467 14.165Z",
    fill: "url(#paint13_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0328 25.8421C11.0778 27.4956 9.97181 28.6444 9.97181 28.6444C9.97181 28.6444 10.412 27.1113 11.367 25.4577C11.5706 25.1094 11.7776 24.7886 11.9824 24.4863C11.2246 24.7492 9.73746 25.4062 8.97089 26.7346C7.91632 28.559 8.63908 30.9507 8.63908 30.9507C8.63908 30.9507 11.0713 30.3812 12.1248 28.5568C12.8924 27.2284 12.7183 25.6121 12.5661 24.8269C12.4073 25.151 12.2332 25.4883 12.0328 25.8421Z",
    fill: "url(#paint14_linear_2547_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.529 6.12483C23.4828 4.47125 24.5888 3.32359 24.5888 3.32359C24.5888 3.32359 24.1486 4.85562 23.1926 6.50812C22.9911 6.85526 22.7841 7.17941 22.5804 7.47837C23.3371 7.21664 24.8243 6.55959 25.5897 5.23233C26.6443 3.40791 25.9215 1.01514 25.9215 1.01514C25.9215 1.01514 23.4915 1.58568 22.437 3.4101C21.6671 4.73845 21.8423 6.35371 21.9945 7.13998C22.1522 6.81693 22.3253 6.47636 22.529 6.12483Z",
    fill: "url(#paint15_linear_2547_781)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_781",
    x1: 17.0958,
    y1: 13.6375,
    x2: 17.0958,
    y2: 18.7249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2547_781",
    x1: 15.0899,
    y1: 10.7275,
    x2: 15.0899,
    y2: 33.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2547_781",
    x1: 14.0505,
    y1: 9.27881,
    x2: 14.0505,
    y2: 11.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2547_781",
    x1: 23.8013,
    y1: 15.3718,
    x2: 23.8013,
    y2: 16.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2547_781",
    x1: 20.5117,
    y1: 9.28101,
    x2: 20.5117,
    y2: 11.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2547_781",
    x1: 17.2808,
    y1: 3.09253,
    x2: 17.2808,
    y2: 8.51433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2547_781",
    x1: 8.52889,
    y1: 9.3584,
    x2: 8.52889,
    y2: 12.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2547_781",
    x1: 26.0322,
    y1: 19.4019,
    x2: 26.0322,
    y2: 22.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2547_781",
    x1: 8.52651,
    y1: 19.4014,
    x2: 8.52651,
    y2: 22.6088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2547_781",
    x1: 26.0338,
    y1: 9.35669,
    x2: 26.0338,
    y2: 12.5636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2547_781",
    x1: 10.5483,
    y1: 1.01904,
    x2: 10.5483,
    y2: 7.48008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2547_781",
    x1: 24.0155,
    y1: 24.4873,
    x2: 24.0155,
    y2: 30.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2547_781",
    x1: 3.63351,
    y1: 14.1606,
    x2: 3.63351,
    y2: 17.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2547_781",
    x1: 30.9273,
    y1: 14.165,
    x2: 30.9273,
    y2: 17.8062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2547_781",
    x1: 10.5478,
    y1: 24.4863,
    x2: 10.5478,
    y2: 30.9507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2547_781",
    x1: 24.0127,
    y1: 1.01514,
    x2: 24.0127,
    y2: 7.47837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2547_781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.56,
    height: 34.56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyLifestyleIcon);
export default __webpack_public_path__ + "static/media/healthy-lifestyle-icon.7c1d9d7f1865f01aacb60e0c54e4f63a.svg";
export { ForwardRef as ReactComponent };